import React, { useEffect, useState, useContext } from "react";
import TimeCompContext from '../../context/TimerCompContext'
import '../../Styles/SMSComp.css'

const TimerComp = () => {

    const [dataTimeContext, setTimeContext] = useContext(TimeCompContext);
    const { minutes = 0, seconds = 60 } = dataTimeContext;
    const [[mins, secs], setTime] = useState([minutes, seconds]);

    const Countdown = () => {
        if (mins === 0 && secs === 0) {
            setTime([- 0, 0, 0]);
            setTimeContext({ minutes: 0, seconds: 0 })
        } else if (secs === 0) {
            setTime([mins - 1, 59]);
        } else {
            setTime([mins, secs - 1]);
        }
    };

    useEffect(() => {
        const timerId = setInterval(() => Countdown(), 1000);
        return () => clearInterval(timerId);
    });


    return (
        <span className="label-exp">{`${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`}</span>
    );
}

export default TimerComp;